import { db } from "../../server";
import { interpolate } from "../helpers/stringHelper";
import { paths } from "../constants/dbPaths";

export function getStoreBySlug(slug) {
  return db.collection(paths.StoreCollection).where("Slug", "==", slug)
}
export function getStore(id) {
  return db.collection(paths.StoreCollection).doc(id);
}
export function getBlackoutDates(storeId) {
  return db.doc(interpolate(paths.BlackoutDatesCollection, storeId));
}
export function getStoreByHqID(HqID) {
  return db.collection(paths.StoreCollection).where("HQCompanyID", "==", HqID);
}
export function getStoreWithName(name) {
  return db.collection(paths.StoreCollection).where("Name", "==", name);
}
export function getStores() {
  return db.collection(paths.StoreCollection).where("IsTest", "==", false);
}
export function getHQStore() {
  return db.collection(paths.StoreCollection).where("IsHQ", "==", true);
}
export function getStoreMenus(storeId) {
  return db.collection(interpolate(paths.StoreMenus, storeId));
}
export function getMenuDoc(storeId) {
  return db.doc(interpolate(paths.MenuDoc, storeId));
}
export function getStoreMenuDoc(storeId, menuName) {
  return db.doc(interpolate(paths.StoreMenuDoc, storeId, menuName));
}
export function getStoresSortByDisplayOrder() {
  return db.collection(paths.StoreCollection).orderBy("DisplayOrder");
}
export function getPriceTriggers(storeId) {
  return db.doc(interpolate(paths.PriceTriggersDoc, storeId));
}

export function getProductStatus(storeId) {
  return db.collection(interpolate(paths.ProductStatus, storeId));
}

export function getBrandedTermsAndConditions() {
  return db.doc(interpolate(paths.BasicDoc));
}
